import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { getCartDetails, updateCartLine, removeCartLine, CART_EVENT } from "@/lib/shopify";

export function useCart() {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    setCart(await getCartDetails());
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener(CART_EVENT, refresh);
    return () => window.removeEventListener(CART_EVENT, refresh);
  }, [refresh]);

  const update = async (lineId, qty) => {
    setBusy(true);
    try { qty <= 0 ? await removeCartLine(lineId) : await updateCartLine(lineId, qty); }
    catch (e) { toast.error(e.message || "Could not update cart."); }
    finally { setBusy(false); }
  };

  return { cart, lines: cart?.lines || [], count: cart?.totalQuantity || 0, loading, busy, update, refresh };
}
